/**
 * Shipping log, newest first.
 *
 * Every entry maps to something that actually landed, this is read by people
 * deciding whether the API will still be maintained next quarter, so an entry
 * that describes intent rather than a shipped change is worse than no entry.
 * Dates are ISO so `<time dateTime>` and the sort below agree.
 */
export type ChangelogEntry = {
    date: `${number}-${number}-${number}`;
    /** One line, past tense, written for someone integrating, not a commit subject. */
    summary: string;
};

export const CHANGELOG: ChangelogEntry[] = [
    {
        date: '2026-08-09',
        summary: 'API and console collapsed onto one origin so the session cookie survives every request.',
    },
    {
        date: '2026-08-08',
        summary: 'Landing demo now seeds from real captured pages, refreshed hourly instead of hand-written.',
    },
    {
        date: '2026-08-08',
        summary: 'Result tables handle long titles and absent shipping values without truncating the row.',
    },
    {
        date: '2026-08-08',
        summary: 'Terms, privacy and refund policy published.',
    },
    {
        date: '2026-08-06',
        summary: 'Public demo search added, five keywords, no key, no account.',
    },
    {
        date: '2026-08-05',
        summary: 'Billing live through Stripe Checkout. New accounts are issued a key on first sign-in.',
    },
    {
        date: '2026-08-04',
        summary: 'itemLocation split out from shipping, and the marketplace list narrowed to countries we parse cleanly.',
    },
    {
        date: '2026-08-04',
        summary: 'Worker moved to standby, so the first request of the day no longer pays a cold start.',
    },
];

/**
 * Newest date in the log. The footer reads this rather than hard-coding one,
 * so adding an entry updates the footer and nothing has to be remembered.
 */
export const LAST_SHIPPED: string = CHANGELOG.reduce(
    (latest, entry) => (entry.date > latest ? entry.date : latest),
    CHANGELOG[0]?.date ?? '',
);
